// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem } from 'components';
import React, { ReactElement, useEffect, useState } from 'react';

import './authorizationEnergy.scss';
import { useTranslation } from 'react-i18next';

import useCheckColor from 'store/hooks/useCheckColor';
import {
  AuthorizationEnergyModel,
  AuthorizationPlaceOfValidityDetail,
} from 'api/types/Qualifications';

interface Props {
  userId: number | null;
  dataAuthorizationEnergy: AuthorizationEnergyModel[] | null | undefined;
}

const AuthorizationEnergy = (props: Props): ReactElement => {
  const { userId, dataAuthorizationEnergy } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  const place = (
    placeOfValidity: AuthorizationPlaceOfValidityDetail
  ): string => {
    let toReturn = placeOfValidity.name;

    if (
      placeOfValidity.description !== null &&
      placeOfValidity.description !== ''
    ) {
      toReturn += ` - ${placeOfValidity.description}`;
    }

    return toReturn;
  };

  const getDefaultValue = (
    id: number,
    keyName: string,
    getIdFromList: boolean
  ) => {
    if (dataAuthorizationEnergy != null) {
      return Object.keys(dataAuthorizationEnergy).map((k) => {
        const searchObject = dataAuthorizationEnergy?.[
          k
        ]?.authorizationEmployeeDetailCurrent?.find((v) => v.id === id);

        if (searchObject) {
          if (getIdFromList && getIdFromList === true) {
            const listId: number[] = [] as number[];
            if (searchObject?.[keyName].length > 0) {
              searchObject?.[keyName].forEach((v) => {
                listId.push(v.id);
              });
            }
            return listId;
          }
          return searchObject?.[keyName];
        }
        return null;
      });
    }

    return undefined;
  };

  return (
    <>
      {dataAuthorizationEnergy &&
      dataAuthorizationEnergy !== null &&
      Object.keys(dataAuthorizationEnergy)?.length > 0 ? (
        <Box
          id="userAuthorizationEnergyBox"
          name={t('userAuthorizationEnergy.authorizationEnergy')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userAuthorizationEnergyContent">
            {Object.keys(dataAuthorizationEnergy)?.map((k) => (
              <DesktopItem
                id="qualifications"
                name={dataAuthorizationEnergy?.[k]?.name}
              >
                <>
                  {dataAuthorizationEnergy?.[k]?.positions !== null &&
                  Object.keys(dataAuthorizationEnergy?.[k]?.positions)
                    ?.length ? (
                    <div className="authorizationEnergyDetailBox">
                      <div className="authorizationEnergyLabel">
                        {t('userAuthorizationEnergy.positions')}
                      </div>
                      <div className="authorizationEnergyValue">
                        {Object.values(
                          dataAuthorizationEnergy?.[k]?.positions ?? {}
                        ).join(', ')}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationEnergy?.[k]?.authorizationNumber !== null &&
                  dataAuthorizationEnergy?.[k]?.authorizationNumber !== ' ' &&
                  dataAuthorizationEnergy?.[k]?.authorizationNumber !== '' ? (
                    <div className="authorizationEnergyDetailBox">
                      <div className="authorizationEnergyLabel">
                        {t('userAuthorizationEnergy.authorizationNumber')}
                      </div>
                      <div className="authorizationEnergyValue">
                        {dataAuthorizationEnergy?.[k]?.authorizationNumber}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationEnergy?.[k]
                    ?.authorizationEmployeeDetailCurrent !== null &&
                  Object.keys(
                    dataAuthorizationEnergy?.[k]
                      ?.authorizationEmployeeDetailCurrent
                  )?.length ? (
                    <div className="authorizationEnergyDetailBox">
                      <div className="authorizationEnergyLabel">
                        {dataAuthorizationEnergy?.[k]?.authorizationId === 2
                          ? t('userAuthorizationEnergy.authorizationTo')
                          : t(
                              'userAuthorizationEnergy.authorizationToPerformOperationalWorkAtThePosition'
                            )}
                      </div>
                      {dataAuthorizationEnergy &&
                      dataAuthorizationEnergy?.[k]?.authorizationId === 2 &&
                      dataAuthorizationEnergy?.[
                        k
                      ]?.authorizationEmployeeDetailCurrent.find(
                        (f) =>
                          f.authorizationDocumentName ===
                            'a) przy urządzeniach el-en Gr.1 do {value} kV,' ||
                          f.authorizationDocumentName ===
                            'b) przy urządzeniach cieplno-mechanicznych Gr.2,' ||
                          f.authorizationDocumentName ===
                            'c) przy urządzeniach gazowych Gr.3,'
                      ) ? (
                        <div className="authorizationEnergyValue">
                          1.Wystawiania poleceń pisemnych na prace:
                        </div>
                      ) : (
                        ''
                      )}
                      {dataAuthorizationEnergy?.[
                        k
                      ]?.authorizationEmployeeDetailCurrent?.map((v) => {
                        return (
                          <>
                            {v?.authorizationDocumentName ===
                            'a) przy urządzeniach el-en Gr.1 do {value} kV,' ? (
                              <div className="authorizationEnergyValue">
                                {`a) przy urządzeniach el-en Gr.1 do ${getDefaultValue(
                                  v?.id,
                                  'additionalValue',
                                  false
                                )} kV,`}
                              </div>
                            ) : (
                              <div className="authorizationEnergyValue">
                                {v?.authorizationDocumentName}
                              </div>
                            )}
                          </>
                        );
                      })}
                    </div>
                  ) : (
                    ''
                  )}
                  {dataAuthorizationEnergy?.[k]
                    ?.authorizationDictionaryDetail !== null &&
                  dataAuthorizationEnergy?.[k]?.authorizationDictionaryDetail
                    ?.length > 0 ? (
                    <div className="authorizationEnergyDetailBox">
                      <div className="authorizationEnergyLabel">
                        {t('userAuthorizationEnergy.theAuthorizationConcerns')}
                      </div>
                      <div className="authorizationEnergyValue">
                        {dataAuthorizationEnergy?.[
                          k
                        ]?.authorizationDictionaryDetail?.map((item) => (
                          <div key={item.id}>{item.name}</div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationEnergy?.[k]?.placeOfValidity &&
                  dataAuthorizationEnergy?.[k]?.placeOfValidity !== null ? (
                    <div className="authorizationEnergyDetailBox">
                      <div className="authorizationEnergyLabel">
                        {t('userAuthorizationEnergy.placeOfValidity')}
                      </div>
                      <div className="authorizationEnergyValue">
                        {place(dataAuthorizationEnergy?.[k]?.placeOfValidity)}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationEnergy?.[k]?.authorizationDate !== null ? (
                    <div className="authorizationEnergyDetailBox">
                      <div className="authorizationEnergyLabel">
                        {t('userAuthorizationEnergy.authorizationDate')}
                      </div>
                      <div className="authorizationEnergyValue">
                        {dataAuthorizationEnergy?.[k]?.authorizationDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {dataAuthorizationEnergy?.[k]?.expirationAuthorizationDate !==
                  null ? (
                    <div
                      className={`dateAuthorizationEnergyBox ${checkColor(
                        dataAuthorizationEnergy?.[k]
                          ?.expirationAuthorizationDate,
                        'uprawnienia',
                        'upowaznieniaEnergetyczne'
                      )}`}
                    >
                      <div
                        className={`dateAuthorizationEnergyLabel ${checkColor(
                          dataAuthorizationEnergy?.[k]
                            ?.expirationAuthorizationDate,
                          'uprawnienia',
                          'upowaznieniaEnergetyczne'
                        )}`}
                      >
                        {t(
                          'userAuthorizationEnergy.expirationAuthorizationDate'
                        )}
                      </div>
                      <div
                        className={`dateAuthorizationEnergyValue ${checkColor(
                          dataAuthorizationEnergy?.[k]
                            ?.expirationAuthorizationDate,
                          'uprawnienia',
                          'upowaznieniaEnergetyczne'
                        )}`}
                      >
                        {
                          dataAuthorizationEnergy?.[k]
                            ?.expirationAuthorizationDate
                        }
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="borderTop" />
                </>
              </DesktopItem>
            ))}
          </div>
        </Box>
      ) : null}
    </>
  );
};

export default AuthorizationEnergy;
